/** Esteira de conteúdo de um cliente (grade de posts). Onda 14. */
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import type { PostDTO } from "@unik/shared";
import { api } from "../../lib/api";
import { AdminShell } from "../../ui/AdminShell";
import { Button } from "../../ui/Button";
import { Card, EmptyState, Skeleton } from "../../ui/Card";
import { PurposeBadge, StatusBadge } from "../../ui/Badge";

export function Esteira() {
  const { id } = useParams();
  const [posts, setPosts] = useState<PostDTO[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [sending, setSending] = useState(false);

  async function load() {
    try {
      setPosts(await api.get<PostDTO[]>(`/clients/${id}/posts`));
    } catch {
      setError("Não foi possível carregar a esteira.");
    }
  }
  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const drafts = posts?.filter((p) => p.status === "draft" || p.status === "revision_requested") ?? [];

  async function enviar() {
    setSending(true);
    try {
      await api.post(`/clients/${id}/posts/send`);
      await load();
    } finally {
      setSending(false);
    }
  }

  return (
    <AdminShell>
      <div className="flex items-center justify-between gap-3">
        <div>
          <Link to={`/clientes/${id}`} className="type-caption text-text-tertiary">
            ← Voltar ao cliente
          </Link>
          <h1 className="type-h1 mt-1 text-text-cream">Esteira</h1>
        </div>
        <Link to={`/clientes/${id}/esteira/novo`}>
          <Button size="sm">Novo post</Button>
        </Link>
      </div>

      {drafts.length > 0 && (
        <div className="mt-5">
          <Button variant="secondary" onClick={enviar} loading={sending}>
            Enviar {drafts.length} para aprovação
          </Button>
        </div>
      )}

      {error !== null && <p className="type-body mt-6 text-danger">{error}</p>}

      {posts === null && error === null && (
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
          <Skeleton className="aspect-square" />
          <Skeleton className="aspect-square" />
          <Skeleton className="aspect-square" />
        </div>
      )}

      {posts?.length === 0 && (
        <EmptyState
          title="Nenhum post ainda"
          description="Suba o primeiro conteúdo do mês para esta cliente."
          action={
            <Link to={`/clientes/${id}/esteira/novo`}>
              <Button>Novo post</Button>
            </Link>
          }
        />
      )}

      {posts !== null && posts.length > 0 && (
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
          {posts.map((p) => (
            <Link key={p.id} to={`/clientes/${id}/posts/${p.id}`}>
              <Card interactive className="overflow-hidden !p-0">
              {p.media[0] !== undefined && (
                <img src={p.media[0].publicUrl} alt="" className="aspect-square w-full object-cover" />
              )}
              <div className="p-3">
                <div className="flex flex-wrap items-center gap-1.5">
                  <PurposeBadge purpose={p.purpose} />
                  <StatusBadge status={p.status} audience="admin" />
                </div>
                <p className="type-caption mt-2 line-clamp-2 text-text-secondary">
                  {p.caption === "" ? "—" : p.caption}
                </p>
              </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </AdminShell>
  );
}
